// @LTG-ID: data-paths
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-009
// @CHANGED: 2026-02 session_002
// @OWNER: web
//
// Three-paths (Grow / Value / Exit) data. Ported verbatim from
// /app/source_reference/Landing Page.html lines 1421-1446.

export const PATHS = [
    {
        num: "Path 01",
        title: "Grow",
        desc:
            "You're scaling, hiring, and the books haven't kept up. We install the financial spine the next phase needs.",
        list: [
            "Monthly bookkeeping & close",
            "Outsourced CFO and advisory",
            "Cash-flow & scenario modeling",
            "Entity structuring as you scale",
            "Payroll & compensation design",
        ],
        detailLabel: "Typical engagement",
        detailVal: "Monthly retainer",
    },
    {
        num: "Path 02",
        title: "Value",
        desc:
            "You want a defensible number for a partner buy-in, an SBA loan, an estate, or simply to know.",
        list: [
            "Business valuation work",
            "Quality-of-earnings review",
            "Buy-sell support",
            "Entity formation & restructuring",
            "Industry benchmarking",
        ],
        detailLabel: "Engagement window",
        detailVal: "Project-based",
    },
    {
        num: "Path 03",
        title: "Exit",
        desc:
            "You're 12\u201360 months from transition. We architect the exit so the number on the LOI is the number you keep.",
        list: [
            "Exit-readiness diagnostic",
            "Tax strategy & IRS resolution",
            "Transaction structuring",
            "Coordination with M&A advisors",
            "Wealth & succession planning",
        ],
        detailLabel: "Engagement window",
        detailVal: "12 \u2013 60 months",
    },
];
